import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { AttachFile } from '@material-ui/icons'
import { AttachmentDialog } from 'components/Dialog/AttachmentDialog'
import { useDocumentListingQuery } from 'generated/graphql'
import { AttachmentDetailView } from 'helpers/Hooks/attachmentDetailsView'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

export const WriteOffDisposalDetailContent = (props: any) => {
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const { listEl, documentListing, listStatus, userList } = props
  const [openDoc, setOpenDoc] = useState<boolean>(false)
  const { menu } = useMenuOption()

  const {
    loading: DocumentLoading,
    data: { DocumentListing } = { DocumentListing: [] },
  } = useDocumentListingQuery({
    fetchPolicy: 'network-only',
    variables: { refID: listEl?.disposal_id },
  })

  return (
    <>
      {DocumentLoading && <Loading />}

      <div className="content-wrap left ">
        <div className="desc " style={{ color: 'grey' }}>
          Doc No
        </div>
        <div className="mdDesc text-noflow">{listEl?.DocNo}</div>
      </div>

      <div className="content-wrap right">
        {DocumentListing && DocumentListing?.length > 0 && (
          <span
            style={{ float: 'right', color: '#000', cursor: 'pointer' }}
            onClick={e => {
              setOpenDoc(true)
            }}
          >
            <AttachFile
              className="mdDesc"
              style={{ fontSize: 12, color: 'orange' }}
            />

            <span
              className="mdDesc"
              style={{
                float: 'right',
                color: 'orange',
                textDecoration: 'underline',
                paddingRight: '5px',
                paddingTop: '4px',
              }}
            >
              {DocumentListing?.length}
            </span>
          </span>
        )}
      </div>

      <div className="content-wrap left ">
        <div className="desc " style={{ color: 'grey' }}>
          {'Asset Name'}
        </div>
        <div className="mdDesc text-noflow"> {listEl?.Asset?.name} </div>
      </div>
      <div className="content-wrap right ">
        <div className="desc " style={{ color: 'grey' }}>
          {'Disposal Method'}
        </div>
        <div className="mdDesc text-noflow"> {listEl?.disposal_method} </div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Disposal Value'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.disposal_value)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Disposal Expenses'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.disposal_expenses)}
        </div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Disposal Gain/loss'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.disposal_gain_loss)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Book Value'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.book_value)}
        </div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {userList?.filter(user => user.ID == listEl?.submittedBy)[0]?.name}
        </div>
      </div>

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]?.name}
            </div>
          </div>
        </>
      )}

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Reason'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason}</div>
      </div>

      <AttachmentDialog
        title="Write-Off / Disposal"
        menu={menu}
        openDoc={openDoc}
        setOpenDoc={setOpenDoc}
        AttachmentDetailView={AttachmentDetailView}
        DocumentListing={DocumentListing}
      />
    </>
  )
}
